import { jsx } from "react/jsx-runtime";
import { DatePickerFieldWUT } from "../../../ui/date-picker-field/date-picker-field-wut.js";
import { FIELD_TYPES } from "../../../constants/field-types.js";
const DatePickerWUT = (props) => {
  const fieldType = FIELD_TYPES.DATE_PICKER;
  return /* @__PURE__ */ jsx(DatePickerFieldWUT, { ...props, fieldType });
};
export {
  DatePickerWUT
};
//# sourceMappingURL=date-picker-wut.js.map
